/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithOrganizationItemRequestBuilder, WithOrganizationItemRequestBuilderNavigationMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/v1/organizations
 */
export interface OrganizationsRequestBuilder extends BaseRequestBuilder<OrganizationsRequestBuilder> {
    /**
     * Gets an item from the MomentumAPI.api.v1.organizations.item collection
     * @param organizationId Unique identifier of the item
     * @returns {WithOrganizationItemRequestBuilder}
     */
     byOrganizationId(organizationId: string) : WithOrganizationItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const OrganizationsRequestBuilderUriTemplate = "{+baseurl}/api/v1/organizations";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const OrganizationsRequestBuilderNavigationMetadata: Record<Exclude<keyof OrganizationsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byOrganizationId: {
        navigationMetadata: WithOrganizationItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["organizationId"],
    },
};
/* tslint:enable */
/* eslint-enable */
